import type { CloudWorkspace } from "@afar-research/contracts";

/**
 * The workspace this page keeps connected. A route that names one in the account's answered listing
 * picks it; any other route keeps the session's earlier pick, so moving around the app never drops
 * the connection. The caller records the answer as the session's pick.
 */
export function selectedCloudWorkspaceId(input: {
  readonly workspaces: ReadonlyArray<Pick<CloudWorkspace, "id">>;
  readonly routeEnvironmentId?: string | null;
  readonly sessionSelected: string | null;
}): string | null {
  const route = input.workspaces.find((workspace) => workspace.id === input.routeEnvironmentId);
  const candidate = route?.id ?? input.sessionSelected;
  return input.workspaces.some((workspace) => workspace.id === candidate) ? candidate : null;
}
